import React, { useEffect, useState } from "react";
import ReactSelect from "react-select";
import { useAllFilterBaseContext } from "../../../../../Context/AllFilterBaseContext";

export default function SubcategoryWithoutfilter({ values }) {
  const [allSkills, setAllSkills] = useState([]);
  const [selectSkills, setSelectSkills] = useState(null);
  const { state, setSubcategories } = useAllFilterBaseContext();
  const { subcategories, industries, keywords } = state;

  useEffect(() => {
    setAllSkills(values);
  }, [values]);

  const handleLanguageChange = (selectedOption) => {
    const newLanguage = {
      id: selectedOption.value,
      title: selectedOption.label,
    };
    const updatedSkills = [...subcategories, newLanguage];
    setSubcategories(updatedSkills);
  };

  const handleDeleteLanguage = (id) => {
    const updatedLanguages = subcategories.filter(
      (language) => language.id !== id
    );
    setSubcategories(updatedLanguages);
  };

  return (
    <div>
      <ReactSelect
        options={
          Array.isArray(allSkills)
            ? allSkills
              .filter(cat => !subcategories.some(s => s.id == cat.id))  
              .map(cat => ({
                value: cat.id,
                label: cat.title,
              }))
            : []
        }
        placeholder="Search subcategories"
        isClearable={true}
        value={selectSkills}
        onChange={(options) => {
          if (options) {
            handleLanguageChange(options);
          }
        }}
      />

      <div className="add-skills">
        {Array.isArray(subcategories) &&
          subcategories.map((skills, index) => (
            <div key={index}>
              <p onClick={() => handleDeleteLanguage(skills.id)}>
                {skills.title} <span>x</span>
              </p>
            </div>
          ))}
      </div>
    </div>
  );
}
